var mcb = mcb || {};

mcb.newswheel =
  mcb.newswheel ||
  new (function () {
    this.init = function () {
      const newswheel = document.querySelector(".news-wheel");

      var index = -1;

      if (newswheel) {
        const blocks = newswheel.querySelectorAll(".news-wheel__item");

        updateNews();
      }

      function updateNews() {
        var items = newswheel.querySelectorAll(".news-wheel__item");
        var timeOut = 5000;

        if (items.length === 1) {
          items[0].classList.toggle("active");
          timeOut = 3000;
        } else {
          var item = newswheel.querySelector(".news-wheel__item.active");

          if (item) {
            item.classList.remove("active");
          }

          index = (index + 1) % items.length;
          items[index].classList.add("active");
        }

        setTimeout(updateNews, timeOut);
      }
    };
  })();
